import styles from './styles';
import SettingsTab from '../SettingsTab';

const savedColorsSettings = {
    default: [
        {
            hoverControl: false,
            label: 'Global Colors',
            modules: [
                {
                    template: 'GlobalSavedColors',
                },
            ],
        },
    ],
};

const globalSettings = [
    new SettingsTab({
        title: 'Styles',
        content: styles,
        icon: ['far', 'pencil-paintbrush'],
    }),
    new SettingsTab({
        title: 'Global Colors',
        icon: ['far', 'globe'],
        content: savedColorsSettings,
    }),
    new SettingsTab({
        content: {},
        title: 'Advanced',
        icon: ['far', 'laptop-code'],
    }),
];

export default globalSettings;
